import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'date-controls.label',
    defaultMessage: 'Date',
  },
  today: {
    id: 'date-controls.stepper.today',
    defaultMessage: 'Today, {date, date, medium-no-year}',
  },
});
